/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: network-search-view-component
 *
 * Created by rwilliams on 7/19/17.
 */
'use strict';
function NetworkSearchViewController (
    $location,
    uiGridConstants,
    NetworkViewService,
    ModalService,
    SearchFilterService
) {
	var self = this;

	var getData = function () {
		self.loadingIndicator.show = true;
		self.searchText = $location.search().searchText || null;

		NetworkViewService.getSearchViewData({fetchLimit : 0, searchString: self.searchText}).then(function (data) {
			self.gridOptions.data = data;
			self.loadingIndicator.show = false;
		});
	};

	var getPermissions = function () {
		NetworkViewService.getViewPermissions(NetworkViewService.permissionViewStates.NETWORK_VIEW_STATE).then(function (permissions) {
			self.permissions = permissions;
			getData();
		});
	};

	var gridColumns = [
		{
			field: 'name',
			displayName: 'Name',
			sort: {
				direction: uiGridConstants.ASC,
				priority: 0
			},
			cellTemplate: 'components/visual/grid/base-tooltip-template.html'
		},
		{
			field: 'value',
			displayName: 'Value',
			cellTemplate: 'components/visual/grid/base-tooltip-template.html'
		},
		{
			field: 'prefix',
			displayName: 'Prefix',
			cellTemplate: 'components/visual/grid/base-tooltip-template.html'
		},
		{
			field: 'shortDescription',
			displayName: 'Description 1',
			cellTemplate: 'components/visual/grid/base-tooltip-template.html',
			minWidth: 375
		}
	];

	var openConfirmationModal = function (action, resultHandler) {
		var networkName = self.gridApi.selection.getSelectedRows()[0].name;
		ModalService.showMessageModal({
			messageText: 'Are you sure you want to ' + action + networkName + '?',
            pullCancelLeft: true,
			title: (action.charAt(0).toUpperCase() + action.slice(1)) + 'Network',
			showOK: true,
			okText: 'Yes',
			windowClass: 'confirm-modal-sm'
		}, resultHandler);
	};

	var newNetwork = function () {
		$location.url('/meta/networks/edit/-1');
	};

	var editNetwork = function (networkId) {
		$location.url('/meta/networks/edit/' + networkId);
	};

	var cloneNetwork = function (network) {
		var clonedNetwork = angular.copy(network);
		delete clonedNetwork.id;

		NetworkViewService.saveNetwork(clonedNetwork).then(function (data) {
			$location.url('/meta/networks/edit/' + data.id);
		});
	};

	var showCloneConfirmationModal = function () {
		openConfirmationModal('clone ', function () { cloneNetwork(self.gridApi.selection.getSelectedRows()[0]); });
	};

	self.loadingIndicator = {
		backdrop: true,
		show: false,
		title: 'Working',
		message: 'Please wait...'
	};

	self.toolbarButtonDefs = [
		{
			label: 'New',
			enabled: function () { return self.permissions.write; },
			onClick: function () { newNetwork(); }
		},
		{
			label: 'Edit',
			enabled: function () { return self.permissions.read && self.gridApi.selection.getSelectedCount() === 1; },
			onClick: function () { editNetwork(self.gridApi.selection.getSelectedRows()[0].id); }
		},
		{
			label: 'Clone',
			enabled: function () { return self.permissions.write && self.gridApi.selection.getSelectedCount() === 1; },
			onClick: function () { showCloneConfirmationModal(); }
		}
	];

	self.permissions = {
		read: false,
		write: false
	};


	self.onRowDblClick = function (row) {
		editNetwork(row.entity.id);
	};

	self.gridOptions = {
		rowSelection: true,
		enableRowHeaderSelection: false,
		enableSelectAll: true,
		enableColumnResizing: true,
		enablePaginationControls: false,
		useExternalPagination: true,
		enableColumnMenus: false,
		enableFullRowSelection: true,
		rowHeight: 26,
		multiSelect: false,
		columnDefs: gridColumns,
		rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
		onRegisterApi: function (gridApi) {
			self.gridApi = gridApi;
		}
	};

	self.$onInit = function () {
        SearchFilterService.populateCriteriaFromLocationSearch();
		getPermissions();
	};
}

angular.module('prism-ui.network').component('networkSearchView', {
	templateUrl: 'meta/network/searchView/network-search-view-template.html',
	controller: NetworkSearchViewController,
	bindings: {

	}
});
